import { config } from '../Init/Init'
import { closeCXMessenger, isCXmessengerAdded, removeCXMessenger } from './CXMessenger'
import { LiveChatWidget } from '@livechat/widget-react'
import { usePlayerStore } from '../../services/store'
import { useEffect } from 'react'
import { removeZendeskWidget } from './ZendeskWidget'

// Api Documentation: https://platform.text.com/docs/extending-chat-widget/javascript-api

const isLiveChatWidgetAdded = () => {
  return window.LiveChatWidget !== undefined
}

const liveChatAction = action => {
  if (window.LiveChatWidget) {
    window.LiveChatWidget.call(action)
  }
}

const openLiveChatWidget = () => {
  if (window.LiveChatWidget) {
    liveChatAction(config.livechat.actions.maximize)
  }
}

const closeLiveChatWidget = () => {
  liveChatAction(config.livechat.actions.minimize)
  liveChatAction(config.livechat.actions.hide)
}

// may be unecessary but adding for consistency
const removeConflictingHelpWidgets = () => {
  // currently not supporting two help widgets
  if (isCXmessengerAdded()) {
    closeCXMessenger()
    removeCXMessenger()
  }

  // not foolproof
  removeZendeskWidget()
}

const removeLiveChatWidget = () => {
  liveChatAction(config.livechat.actions.destroy)
  liveChatAction(config.livechat.actions.hide)
}

export default function LiveChatModal(props) {
  const playerStore = usePlayerStore()
  const playerLoginUser = playerStore.use.loginUser()

  function onVisibilityChanged(initialData) {
    switch (initialData.visibility) {
      case config.livechat.events.minimized:
        props.onClose()
        liveChatAction(config.livechat.actions.hide)
        break
      case config.livechat.events.maximized:
        props.onOpen()
        break
    }
  }

  removeConflictingHelpWidgets()

  useEffect(() => {
    if (window.LiveChatWidget) {
      console.log('[LiveChat] add')
      window.LiveChatWidget.on('visibility_changed', onVisibilityChanged)
      if (!props.openOnInit) {
        liveChatAction(config.livechat.actions.hide)
      }
    }
  }, [window.LiveChatWidget])

  return playerLoginUser.emailAddress ? (
    <LiveChatWidget
      license={props.license}
      visibility={props.openOnInit ? config.livechat.events.maximized : config.livechat.events.minimized}
      customerEmail={playerLoginUser.emailAddress}
    />
  ) : (
    <LiveChatWidget
      license={props.license}
      visibility={props.openOnInit ? config.livechat.events.maximized : config.livechat.events.minimized}
    />
  )
}

export { openLiveChatWidget, closeLiveChatWidget, isLiveChatWidgetAdded, removeLiveChatWidget }
